export default __webpack_public_path__ + "static/media/copilot-popup.91b4f22a.svg";